import router from '@/router';

function toError(error) {
  if (!error) {
    router.replace('/error');
    return;
  } else if (error.stop) {
    return;
  }

  let errorText = error.message || error;
  router.replace({ name: 'error', params: { errorText: errorText } });
}

const redirect = {
  toError
};

export default redirect;
